import ContactForm from "@/components/forms/ContactForm";
import AnimatedSection from "@/components/ui/AnimatedSection";
import { type SectionProps } from "@/types/types";

export default function ContactSection({delay = 0}: SectionProps) {
  return (
    <AnimatedSection
      id="contact"
      delay={delay}
      className="py-24 border-t-2 border-zinc-800 font-mono"
    >
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-black uppercase text-zinc-50 tracking-tighter">
          CONTACT_SYS
        </h2>
        <div className="w-16 h-1.5 bg-yellow-400 mx-auto mt-3 mb-6" />
        
        <p className="text-zinc-400 text-xs max-w-md mx-auto mb-12 leading-relaxed">
          Open socket. Send a secure transmission packet or reach out through verified social endpoints.
        </p>

        <ContactForm />

        <div className="mt-12 flex justify-center gap-6 text-xs text-zinc-500 font-bold uppercase">
          <a
            href="https://github.com/JuzzJoel"
            target="_blank"
            rel="noreferrer"
            className="text-zinc-500 hover:text-yellow-400 transition-colors"
          >
            &gt; GITHUB
          </a>
          <a
            href="https://www.linkedin.com/in/joel-olajire-0a526a297/"
            target="_blank"
            rel="noreferrer"
            className="text-zinc-500 hover:text-yellow-400 transition-colors"
          >
            &gt; LINKEDIN
          </a>
          <a
            href="mailto:joelolajiire@gmail.com"
            className="text-zinc-500 hover:text-yellow-400 transition-colors"
          >
            &gt; EMAIL_DISPATCH
          </a>
        </div>
      </div>
    </AnimatedSection>
  );
}
